var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "780",
        height: "500",
        "enable-background": "new 0 0 780 500",
        version: "1.1",
        viewBox: "0 0 780 500",
        "xml:space": "preserve",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "m114.26 257.95c-4.8 0.6-13.203 2.399-18.004 6.6-14.403 12.599-6.001 34.798 23.406 34.798 16.803 0 33.607-10.8 46.81-27.6-19.204-8.999-34.808-15.6-52.212-13.8v2e-3z",
          fill: "#2BA6DF",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "m221.83 273.4c27.006 9 33.007 9.6 33.007 9.6v-95.998c0-16.2-13.203-29.399-30.006-29.399h-126.03c-16.204 0-30.007 13.2-30.007 29.4v126c0 16.199 13.203 29.398 30.007 29.398h126.03c16.203 0 30.006-13.2 30.006-29.4v-1.199s-48.01-19.799-72.616-31.799c-16.203 19.799-37.208 32.399-59.413 32.399-37.208 0-49.811-32.399-31.807-53.398 3.6-4.801 10.202-9 20.404-11.4 15.604-3.6 40.81 2.4 64.215 10.199 4.2-7.799 7.801-16.199 10.202-25.199h-72.616v-7.2h37.208v-14.4h-45.61v-7.2h45.61v-18.598s0-3 3-3h18.005v22.2h45.01v6.6h-45.01v13.2h36.608c-3.6 14.399-9.002 27.598-15.604 38.999 12.003 4.199 22.205 7.8 29.407 10.198z",
          fill: "#2BA6DF",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "m340.49 201.22l39.608 85.797h-21.005l-10.802-22.8h-32.408l-10.802 22.8h-13.803l40.209-83.398s1.199-2.4 3.6-2.4h5.402v1e-3zm-21.006 55.198h25.206l-12.603-27-12.603 27zm87.448 31.281h-19.204v-81.598c0-2.4 1.2-3.6 4.2-3.6h15.004v85.198zm36.007-0.558h-19.203v-61.798c0-2.4 1.199-3.6 4.199-3.6h15.004v65.398zm23.483-64.116h12.604v6c2.4-1.8 4.801-3.6 7.801-4.2 3.002-1.2 6.002-1.8 10.203-1.8 4.199 0 7.801 0.6 10.803 2.4 3.6 1.8 6 3.6 8.4 6.6s4.201 6 5.402 9.6c1.199 3.6 1.799 7.2 1.799 11.399 0 5.399-0.6 10.2-2.398 14.4-1.801 4.199-3.602 8.399-6.602 11.399-3.002 3-6.002 5.999-10.203 7.8-4.201 1.799-8.402 2.399-13.203 2.399h-6.602c-1.799 0-3.6-0.601-5.4-1.2v21.6h-19.206v-78.597c-0.599-7.8 2.401-7.8 6.602-7.8zm12.603 46.798c0 1.801 0 3 0.6 4.2s1.201 2.399 2.4 3.601c1.199 1.199 2.4 1.799 3.602 2.399 1.199 0.601 3 0.601 4.801 0.601 1.799 0 3-0.601 4.801-1.801 1.199-1.199 3-2.4 3.602-4.8 0.6-2.399 1.799-4.2 2.398-7.2 0.602-2.999 1.201-5.399 1.201-8.999 0-4.201 0-7.8-0.6-10.8-0.602-3-1.201-5.4-2.4-7.8-1.201-1.8-2.4-3.6-3.6-4.8-1.201-1.2-3.002-1.8-4.803-1.8-1.199 0-2.4 0-3.6 0.6-1.201 0.6-2.4 1.2-3.002 1.8-1.199 0.6-1.799 1.8-3 2.4-1.201 1.2-1.801 1.8-2.4 3v29.4-1e-3zm81.028-46.798c4.801 0 8.402 0.6 12.002 1.2 3 0.6 6.002 1.8 8.402 3.6s3.6 3.6 4.801 5.4c1.199 2.4 1.801 4.8 1.801 7.2v47.398h-19.205v-4.8c-1.199 1.2-2.398 1.8-3 2.399l-3.602 1.801c-1.199 0.6-2.4 1.199-4.199 1.199-1.801 0.601-3.602 0.601-5.402 0.601-3 0-5.4-0.601-7.803-1.2-2.398-0.6-4.199-1.8-6-3.6-1.801-1.2-3.002-3-3.602-5.4-0.6-1.8-1.199-4.199-1.199-6.6s0.6-4.801 1.199-6.6c0.6-1.801 2.4-3.601 3.602-5.4 1.199-1.8 3.6-3 5.4-4.2 2.4-1.2 4.201-2.4 7.203-3.6 2.398-1.199 4.799-1.799 7.801-3 2.4-0.6 5.4-1.8 7.801-2.4l2.4-0.6v-6.6c0-1.8 0-3.6-0.6-5.4l-1.801-3.6c-0.6-0.6-1.799-1.8-2.398-1.8-1.201-0.6-2.4-0.6-3.602-0.6 0 0-10.203 0-19.205 7.8l-4.201-6.6c-1.798 1.201 9.004-6.598 23.407-6.598zm6.599 31.799c-1.799 0.6-3.6 1.801-5.398 3l-5.402 3.6c-1.801 1.201-3 2.4-3.6 4.2-1.201 1.2-1.201 3-1.201 4.2s0 2.4 0.6 3.601c0.6 1.199 0.6 1.8 1.199 3 0.602 1.199 1.201 1.199 1.801 1.8 0.6 0.6 1.201 0.6 2.4 0.6 1.801 0 3.002-0.6 4.801-1.2l5.402-3.6v-19.2h-0.602zm46.555 53.998h-12.604l-0.6-11.399s15.604 0.6 20.404-5.4c1.801-2.4 3-8.999 3-8.999l-31.205-59.998h21.004l19.805 38.999 17.404-39h13.803l-31.807 70.799c-1.2 2.4-6.001 14.999-19.204 14.998z",
          fill: "#3F3A39",
        },
      }),
      _vm._v(" "),
      _c("ellipse", {
        attrs: {
          cx: "433.4",
          cy: "204.1",
          rx: "9.602",
          ry: "8.5",
          fill: "#2BA6DF",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "m683.68 172.91h-6.602v-1.2h14.402v1.2h-6.6v18.599h-1.801v-18.599h0.601zm10.716-1.201h2.4l4.201 11.4 1.801 4.2c0.6-1.2 1.199-3 1.799-4.2l4.201-11.4h2.4v20.4h-2.398v-18l-1.801 4.8-4.201 12h-1.198l-4.201-12-1.801-4.8v18h-1.801v-20.4h0.599z",
          fill: "#3F3A39",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }